// extracted by mini-css-extract-plugin
export default {"container":"Theme_container__YngBW","title":"Theme_title__IYcTD"};